import { LocationSortingTypes } from '../../mui/components/sections/DS_FindInMap/models/LocationSortingTypes';
import { getClosestLocationsByDistance } from '../getClosestLocations';
import { getClosestLocationsByDistanceAndTimeSlots } from './getClosestLocations';

const getClosestLocationsBySortingAlgo = (locations, targetLocation, sortingAlgorithm) => {
  switch (sortingAlgorithm) {
    case LocationSortingTypes.By_Distance:
      return getClosestLocationsByDistance(locations, targetLocation);
    case LocationSortingTypes.By_Distance_And_Timeslots:
      return getClosestLocationsByDistanceAndTimeSlots(locations, targetLocation);
    default:
      return getClosestLocationsByDistance(locations, targetLocation);
  }
};

export { getClosestLocationsBySortingAlgo };
